import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._m(0),_c(VTabs,{attrs:{"centered":""}},[_c(VTab,[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-format-list-bulleted")]),_vm._v("\n      Produtos\n    ")],1)],1),_c(_setup.GridProdutos,{staticClass:"px-2"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-2 background-bar text-uppercase align-center py-1"},[_c('span',{staticClass:"font-12 font-weight-medium"},[_vm._v("\n      Análise parâmetros produtos\n    ")])])
}]

export { render, staticRenderFns }